import {createGlobalStyle} from "styled-components";
import React, {useEffect} from "react";



const Icon = createGlobalStyle`
  .icon{
    width: 1em;
    height: 1em;
    vertical-align: -0.15em;
    fill: currentColor;
    overflow: hidden;
  }
`

const GlobalIcon = () => {
  useEffect(() => {
    // require('../icon/font/iconfont');
  }, [])
  return (
    <Icon/>
  )
}

const IconStyle = () => {
  return null
};

// export default GlobalIcon;
export default IconStyle
